import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '__services';

@Component({
  selector: 'app-flow-panel',
  templateUrl: './flow-panel.component.html',
  styleUrls: ['./flow-panel.component.scss']
})
export class FlowPanelComponent implements OnInit {
  items: any;
  isValid: any;
  isAllJourneyValidated: boolean = true;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() flowCancelReason;
  @Input() set state(value) {
    if (value && this.selectedItem) {
      this.setSelectedItem(this.selectedItem, value.isValid);
    }
  }
  @Input() set data(items) {
    if (items?.length) {
      this.isAllJourneyValidated = true;
      items.forEach((e, i) => {
        e.selected = i === this.prevSelected;
        e.index = i + 1;
        if(e.validate_status === 3 && !e.isOwner && !e.company_personas.some(item => [8, 12].includes(item))) {
          this.isAllJourneyValidated = false
        }
        if(items[0].name === 'Safety Data Sheet') {
          e.step_num = i
        } else {
          e.step_num = i + 1;
        }
      });
      this.items = items;
      if (!this.configObj?.itemSelected) {
        this.configObj.itemSelected = this.items[0];
      }
    }
  }

  
  prevSelected = 0;
  selectedItem: any;

  constructor(
    private translateService: TranslateService
  ) { }

  configObj = {
    title: 'Step',
    height: 60,
    expanded: true,
    itemSelected: null,
    position: 'right-flow-validate',
  };


  ngOnInit(): void {
  }

  onSelected(value, index): void {
    if (this.prevSelected === index) { return; }
    this.selectedItem = Object.assign(value, { index: index + 1 });
    this.valueChanged.emit(this.selectedItem);
  }

  setSelectedItem(value, valid = true): void {
    if (!valid) { return; }
    const index = value.index - 1;
    const selectedItem = this.items[index];
    selectedItem.selected = true;
    // Remove previous
    const prevSelected = this.items[this.prevSelected];
    prevSelected.selected = false;
    this.prevSelected = index;
    Object.assign(this.configObj, { itemSelected: value });
    this.configObj = { ...this.configObj };
  }
}

